import type { NutrientAlternativeGroup } from '../../graphql/api/types'

/** How the current staged upload was produced (drives AI review UI on the upload review page). */
export type AnalysisUploadSource = 'spreadsheet' | 'ai_pdf'

export const UPLOAD_SOURCE = {
  SPREADSHEET: 'spreadsheet',
  AI_PDF: 'ai_pdf',
} as const satisfies Record<string, AnalysisUploadSource>

export type { NutrientAlternativeGroup }
